import React, { useEffect } from "react";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";

import Layout from "../Componants/Layout";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const validationSchema = Yup.object().shape({
  new_password: Yup.string()
    .required("New Password is required")
    .min(6, "Password must be at least 6 characters"),
  confirm_password: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("new_password"), null], "Passwords must match"),
});
export default function ResetPassword() {
  const Navigate = useNavigate()
  const param = useParams()
  console.log("param",param)
  useEffect(() => {
    if (param?.token) {
      localStorage.setItem("forgotToken", param.token);
    }
  }, [param?.token]);
  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      let payload = {
        newPassword: data?.new_password
      }
      return postRequest(`/auth/reset`, payload);
    },
    onSuccess: (data) => {
      if(data?.statusCode == 200) {
        toast.success(`${data?.message}`, {
          iconTheme: {
              primary: '#337FE0',
              secondary: '#FFFAEE',
          },
      })
      Navigate("/", { replace: true });
      }

    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });


  const handleSubmit = (values) => {
    console.log("values", values)
    mutate(values)

  };

  return (
    <Layout>
      <section>
        <div className="comn-form-box">
          <div>
            <h2>Reset Password</h2>
            <p>Please enter the new Password here</p>
            <Formik
              initialValues={{ new_password: "", confirm_password: "" }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched }) => (
                <FormikForm className="cmn-form-set">
                  <div className="mb-3">
                    <label htmlFor="new_password" className="form-label">New Password</label>
                    <Field
                      name="new_password"
                      type="password"
                      placeholder="Enter New Password"
                      className={`form-control ${errors.new_password && touched.new_password ? "is-invalid" : ""}`}
                    />
                    {errors.new_password && touched.new_password && (
                      <div className="invalid-feedback">{errors.new_password}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="confirm_password" className="form-label">Confirm Password</label>
                    <Field
                      name="confirm_password"
                      type="password"
                      placeholder="Enter Confirm Password"
                      className={`form-control ${errors.confirm_password && touched.confirm_password ? "is-invalid" : ""}`}
                    />
                    {errors.confirm_password && touched.confirm_password && (
                      <div className="invalid-feedback">{errors.confirm_password}</div>
                    )}
                  </div>

                  <div className="cmn-form-action">
                    <button type="submit" className="theme-btn">
                      {apiState ? "loading..." : "Confirm"}
                    </button>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </section>
    </Layout>
  );
}
